import type { NodeViewProps, ProseMirrorAttribute } from "ls/common/tiptap-shims";

export interface CanvasLinkAttributes {
  objectId: string;
}

export interface CanvasLinkOptions {
  shortcut?: string;
}

export const CanvasLinkNodeName = "canvasLink";
export type CanvasLinkNodeViewProps = NodeViewProps<CanvasLinkOptions, CanvasLinkAttributes>;
export type CanvasLinkAttributeSpec = Record<keyof CanvasLinkAttributes, ProseMirrorAttribute>;
